module.exports = __webpack_public_path__ + "media/images/admin/logo-62e58301d923a7a4cc43d504aeff5c81.jpg";